function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import HerramientaDibujoBase from './herramienta-dibujo-base';

var Borrador = function (_HerramientaDibujoBas) {
  _inherits(Borrador, _HerramientaDibujoBas);

  function Borrador(grosor) {
    _classCallCheck(this, Borrador);

    var _this = _possibleConstructorReturn(this, _HerramientaDibujoBas.call(this, 'Borrador', null, grosor));

    _this.herramientaDown = function (ctx, x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = _this.grosor; // 50

      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.strokeStyle = 'rgb(0, 0, 0)';
      ctx.beginPath();
      ctx.moveTo(x, y);
      _this.puntos = [{
        x: x,
        y: y
      }];
    };

    _this.herramientaMove = function (ctx, x, y) {
      if (ctx.globalCompositeOperation !== 'destination-out') {
        ctx.globalCompositeOperation = 'destination-out';
      }

      ctx.lineTo(x, y);
      ctx.stroke();

      _this.puntos.push({
        x: x,
        y: y
      });
    };

    _this.herramientaUp = function (ctx, x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = _this.grosor; // 50

      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.strokeStyle = 'rgb(0, 0, 0)';
      ctx.beginPath();
      ctx.moveTo(_this.puntos[0].x, _this.puntos[0].y);

      _this.puntos.forEach(function (_ref) {
        var x = _ref.x,
            y = _ref.y;
        return ctx.lineTo(x, y);
      });

      ctx.stroke();
      _this.puntos = null;
    };

    return _this;
  }

  return Borrador;
}(HerramientaDibujoBase);

export default Borrador;